// import { getLogger } from 'utils/logger';
import { REDUCER_KEY } from './reducer';
// const log = getLogger('data/memorizedRules/selector.js');

export const getMemorizedRulesStore = (state) => state[REDUCER_KEY];
export const getLastSyncDate = (state: any) => getMemorizedRulesStore(state).lastSyncDate;

export const getMemorizedRulesById = (state) => {
  const newState = getMemorizedRulesStore(state);
  return newState.resourcesById;
};

export function getMemorizedRuleById(state, id) {
  if (state.resourcesById) {
    return state.resourcesById.get(id) || null;
  }
  return null;
}

